import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { Layouts } from '~/shared';
import { StyledContainer } from './Background.styled';

const Background: React.FC = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.VehicleMoveDay} />
		)}
		<StyledContainer className={`${Layouts.RadialMenu}-background`} />
	</Fragment>
);

export { Background };
